import React, { useState } from 'react';
import { Modal, Upload, Button, Typography } from 'antd';
import { UploadOutlined, FilePdfOutlined, FileTextOutlined } from '@ant-design/icons';
import { postFile } from '../../../../../utils/fetch';
import { URL_BASE_ORDENESPAGO } from '../../../../../constants/url';

const { Text } = Typography;

export default function ModalCargarComplemento({ visible, onClose, ordenPagoID, onSuccess }) {
  const [xmlFile, setXmlFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [xmlError, setXmlError] = useState(null);
  const [pdfError, setPdfError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleXmlUpload = (file) => {
    const ext = file.name.split('.').pop().toLowerCase();
    if (ext !== 'xml') {
      setXmlError(`El archivo ${file.name} no es XML`);
      setXmlFile(null);
      return false;
    }
    setXmlError(null);
    setXmlFile(file);
    return false;
  };

  const handlePdfUpload = (file) => {
    const ext = file.name.split('.').pop().toLowerCase();
    if (ext !== 'pdf') {
      setPdfError(`El archivo ${file.name} no es PDF`);
      setPdfFile(null);
      return false;
    }
    setPdfError(null);
    setPdfFile(file);
    return false;
  };

  const handleSubmit = async () => {
    if (!xmlFile || !pdfFile) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('ComplementoPagoXml', xmlFile);
      formData.append('ComplementoPagoPDF', pdfFile);
      formData.append('OrdenPagoID', ordenPagoID);

      const result = await postFile(
        `${URL_BASE_ORDENESPAGO}/CargaComplementoPago`,
        formData
      );

      if (result.code === 0) {
        setXmlFile(null);
        setPdfFile(null);
        handleClose();
        if (onSuccess) {
          onSuccess();
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setXmlFile(null);
    setPdfFile(null);
    setXmlError(null);
    setPdfError(null);
    setLoading(false);
    onClose();
  };

  const isDisabled = !xmlFile || !pdfFile;

  return (
    <Modal
      title="Cargar Complemento de Pago"
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          disabled={isDisabled}
          loading={loading}
        >
          Enviar Archivos
        </Button>
      ]}
      width={320}
      wrapClassName="pagos-v2-modal"
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            <FileTextOutlined /> Cargar Complemento XML
          </Text>
          <Upload
            beforeUpload={handleXmlUpload}
            maxCount={1}
            showUploadList={false}
            accept=".xml"
          >
            <Button icon={<UploadOutlined />} block>
              Seleccionar archivo XML
            </Button>
          </Upload>
          {xmlFile && (
            <Text type="success" style={{ display: 'block', marginTop: 4, fontSize: 12 }}>
              ✓ {xmlFile.name}
            </Text>
          )}
          {xmlError && (
            <Text type="danger" style={{ display: 'block', marginTop: 4, fontSize: 12 }}>
              {xmlError}
            </Text>
          )}
        </div>

        <div style={{ width: '100%', textAlign: 'center' }}>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            <FilePdfOutlined /> Cargar Complemento PDF
          </Text>
          <Upload
            beforeUpload={handlePdfUpload}
            maxCount={1}
            showUploadList={false}
            accept=".pdf"
          >
            <Button icon={<UploadOutlined />} block>
              Seleccionar archivo PDF
            </Button>
          </Upload>
          {pdfFile && (
            <Text type="success" style={{ display: 'block', marginTop: 4, fontSize: 12 }}>
              ✓ {pdfFile.name}
            </Text>
          )}
          {pdfError && (
            <Text type="danger" style={{ display: 'block', marginTop: 4, fontSize: 12 }}>
              {pdfError}
            </Text>
          )}
        </div>
      </div>
    </Modal>
  );
}
